<template>
  <div class="text-sm text-neutral-500 my-3">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Help',
}
</script>

<style scoped lang="scss">

</style>
